import { Component }              from '@angular/core';
import { MatDialogRef }            from '@angular/material';
import { Globals }                from './../common/globals';

@Component({
  selector: 'sa-peak-copy-dialog',
  template: require('./peak-copy-dialog.component.html'),
  styles: [require('./peak-copy-dialog.component.scss')]
})
export class PeakCopyDialogComponent {
  public model: any;
  public targetModel: any = {};
  public trains = [];
  public years = [];
  private errors = [];
  public months: number [];

  constructor(
    public globals: Globals,
    public dialogRef: MatDialogRef<PeakCopyDialogComponent>
  ) {
  }

  save() {
    this.errors = [];
    if (!this.targetModel.trainUid || this.targetModel.trainUid.trim().length === 0) {
        this.errors.push('Vyberte prosím spoj');
    }
    if (this.targetModel.month === null || isNaN(this.targetModel.month) || this.targetModel.month % 1 !== 0 ||
        this.targetModel.month < 0  || this.targetModel.month > 2147483647) {
        this.errors.push('Zadejte platný měsíc');
    }
    if (this.targetModel.year === null || isNaN(this.targetModel.year) || this.targetModel.year % 1 !== 0 ||
        this.targetModel.year < 0  || this.targetModel.year > 2147483647) {
        this.errors.push('Zadejte platný rok');
    }
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/peak-copy-dialog/peak-copy-dialog.component.ts